import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Namespace } from '@data/utils/enums';
import { Button } from '@ui/components';
import { getIconStyles } from '../../utils';
import { useHistory } from './hooks';

const iconStyles = getIconStyles();

type HistoryProps = {
  disabled: boolean;
};

export const History = ({ disabled }: HistoryProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);
  const { canRedo, canUndo, undo, redo } = useHistory();

  return (
    <div className="flex items-center gap-1">
      <Button
        onClick={undo}
        disabled={!canUndo || disabled}
        type="text"
        className="p-2 rounded-md"
        title={t('editor.titles.undo')}
      >
        <ArrowLeftOutlined style={iconStyles} />
      </Button>
      <Button
        onClick={redo}
        disabled={!canRedo || disabled}
        className="p-2 rounded-md"
        type="text"
        title={t('editor.titles.redo')}
      >
        <ArrowRightOutlined style={iconStyles} />
      </Button>
    </div>
  );
};
